export default __webpack_public_path__ + "static/media/one_document_green.305b22d5.svg";